import './LoadingBar.css';

export const LoadingBar = () => {
    return <div className="parent bg-gray-300 h-1 w-full">
        <div className="child bg-blue-600 h-1"></div>
    </div>;
};